var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0 pb-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "title": "Текущая специальность",
      "font-size": "15",
      "text-start": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.speciality,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Специальность")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.specialityFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "specialityFrom", $$v);
      },
      expression: "application.specialityFrom"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.courseNumber,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Номер курса")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.courseNumberFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "courseNumberFrom", $$v);
      },
      expression: "application.courseNumberFrom"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.groupNumber,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Группа")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.group,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "group", $$v);
      },
      expression: "application.group"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.paidForm,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Тип обучения")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.paidFormFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "paidFormFrom", $$v);
      },
      expression: "application.paidFormFrom"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.educationForm,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Форма обучения")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.educationFormFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "educationFormFrom", $$v);
      },
      expression: "application.educationFormFrom"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0 pb-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "title": "Желаемая специальность",
      "font-size": "15",
      "text-start": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.speciality,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Специальность")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.specialityTo,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "specialityTo", $$v);
      },
      expression: "application.specialityTo"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.courseNumber,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Номер курса")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.courseNumberTo,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "courseNumberTo", $$v);
      },
      expression: "application.courseNumberTo"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.paidForm,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Тип обучения")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.paidFormTo,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "paidFormTo", $$v);
      },
      expression: "application.paidFormTo"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.educationForm,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Форма обучения")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.educationFormTo,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "educationFormTo", $$v);
      },
      expression: "application.educationFormTo"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }